import { render } from "./QuizItemSelect.vue?vue&type=template&id=741194c4"
import script from "./QuizItemSelect.vue?vue&type=script&lang=js"
export * from "./QuizItemSelect.vue?vue&type=script&lang=js"

import "./QuizItemSelect.vue?vue&type=style&index=0&id=741194c4&lang=css"

import exportComponent from "/Users/ruwan/projects/eopp/eopp-web-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__